import { render, staticRenderFns } from "./CommercialChildcareCentreSingleTenant.vue?vue&type=template&id=978107fe&scoped=true&"
import script from "./CommercialChildcareCentreSingleTenant.vue?vue&type=script&lang=ts&"
export * from "./CommercialChildcareCentreSingleTenant.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialChildcareCentreSingleTenant.vue?vue&type=style&index=0&id=978107fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978107fe",
  null
  
)

export default component.exports